/**
 * @file Purchase PPD Print Package Modal Container.
 */

import { connect } from 'react-redux';
import compose from 'lodash.flowright';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';

import PurchasePpdItemPurchaseModal from '../../components/purchase/PurchasePpdItemPurchaseModal';
import { openModal } from '../../actions/modal-actions';
import { AlbumForPpdPurchase } from '../../graphql/queries/albums';
import { MeForAlbumPurchase } from '../../graphql/queries/account';

const withAlbumForPpdPurchase = graphql(AlbumForPpdPurchase, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
    },
  }),
  props: ({ data: { album, loading } }) => ({
    album,
    loading,
  }),
});

const mapStateToProps = ({ ppdPurchase }) => ({
  cart: ppdPurchase.cart,
  activeIdentity: ppdPurchase.selectedIdentity,
});

const mapDispatchToProps = {
  openModal,
};

const withMeForAlbumPurchase = graphql(MeForAlbumPurchase, {
  options: ({ match }) => ({
    variables: {
      albumId: match.params.albumId,
    },
  }),
  props: ({ data: { me } }) => ({
    user: me,
  }),
});

export default compose(
  withRouter,
  withAlbumForPpdPurchase,
  withMeForAlbumPurchase,
  connect(mapStateToProps, mapDispatchToProps),
)(PurchasePpdItemPurchaseModal);
